import { render, staticRenderFns } from "./MainHead.vue?vue&type=template&id=01328088"
import script from "./MainHead.vue?vue&type=script&lang=js"
export * from "./MainHead.vue?vue&type=script&lang=js"
import style0 from "./MainHead.vue?vue&type=style&index=0&id=01328088&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports